export class ModelGroupFilter {
    
    public SectionID?: number;
    public EquipmentTypeID?: number;
    public IncludeInactive?: boolean;
}

export default ModelGroupFilter;